import {KeyedProblemErrors, ProblemDetails, ServiceError} from '../types';

/** Every message carried in ProblemDetails.errors, in either shape. */
export function problemErrorMessages(problemDetails: ProblemDetails): string[] {
    const {errors} = problemDetails;
    if (!errors) {
        return [];
    }

    if (Array.isArray(errors)) {
        return errors
            .map((error: ServiceError) => error.message)
            .filter((message): message is string => !!message);
    }

    return Object.values(errors as KeyedProblemErrors).flatMap(value =>
        Array.isArray(value) ? value : [String(value)]
    );
}

export function hasProblemErrors(problemDetails: ProblemDetails): boolean {
    return problemErrorMessages(problemDetails).length > 0;
}
